import { render, staticRenderFns } from "./ClicksCount.vue?vue&type=template&id=3ba5fa94&scoped=true"
import script from "./ClicksCount.vue?vue&type=script&lang=ts"
export * from "./ClicksCount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba5fa94",
  null
  
)

export default component.exports